import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card} from 'antd';
import {getFee, getFeeRates} from './actions';
import {bindActionCreators} from "redux";
import moment from "moment";
import ResponsiveTable from "../common/ResponsiveTable";
import {decodeParams} from "../utils/params";

const feeRatesColumns = [
  {
    title: 'Effective Date',
    dataIndex: 'effectiveDate',
    key: 'effectiveDate',
    render: value => moment(value, moment.ISO_8601).format('YYYY-MM-DD HH:mm:ss')
  },
  {
    title: 'Rate',
    dataIndex: 'rate',
    key: 'rate'
  },
];

class FeeRatesPage extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.feeId !== prevProps.match.params.feeId) this._load();
  }

  _load = (newPagination) => {
    const {feeId} = decodeParams(this.props.match.params);
    const {pagination} = this.props;
    this.props.getFee({feeId});
    this.props.getFeeRates({feeId, pagination: newPagination || pagination});
  };

  handleAdd = e => {
    const {feeId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.history.push('/fee/add-rate/' + feeId);
  };

  render() {
    const {loading, fee, feeRates, pagination, history} = this.props;
    return (
      <Card
        title={[
          <Button key="back" icon="arrow-left" onClick={() => history.goBack()} />,
          ` ${fee.name} Rates`
        ]}
        extra={<Button type="primary" icon="plus" onClick={this.handleAdd}>Add</Button>}
      >
        <ResponsiveTable
          loading={loading}
          columns={feeRatesColumns}
          dataSource={feeRates}
          rowKey={row => (`${row.feeId}-${row.rateId}`)}
          pagination={pagination}
          onChange={this._load}
        />
      </Card>
    );
  }
}

FeeRatesPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  getFeeRates: PropTypes.func.isRequired,
  feeRates: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  getFee: PropTypes.func.isRequired,
  fee: PropTypes.object.isRequired,
  pagination: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  feeRates: state.fee.feeRates,
  loading: state.fee.feeLoading || state.fee.feeRatesLoading,
  fee: state.fee.fee || {},
  pagination: state.fee.feeRatesPagination,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getFee,
  getFeeRates,
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FeeRatesPage);



// WEBPACK FOOTER //
// ./src/Fee/FeeRatesPage.js